<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'SELLER_DETAILS.GENERAL_TAB_LABEL' | translate }}</h3>
    </div>

    <div class="sp-row__align">
      <div class="sp-row__align sp-row__justify-center">
        <mat-icon
          [ngClass]="{
            'sp-color__green': buyer?.is_confirmed,
            'sp-color__red': !buyer?.is_confirmed
          }"
          class="sp-padding__right-x4">
          check_circle
        </mat-icon>
        <app-shared-pill
          [content]="getOnboardingStatus()"
          [content_class]="'sp-color__primary'"
          [pill_class]="'sp-background__status-500'"
          [is_clear_enabled]="false"></app-shared-pill>
      </div>
    </div>
  </div>
  <div class="sp-width__full sp-margin__top-x2 sp-buyer-details-general-info__grid sp-grid__column-gap-x2">
    <app-shared-info-copy
      [label]="'BUYERS.ID_COLUMN_LABEL'"
      [content]="buyer?.buyer_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'GENERAL.REGISTRATION_DATE_LABEL'"
      [content]="(buyer?.created_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.LAST_LOGIN_LABEL'"
      [content]="(buyer?.last_login_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.NAME_LABEL'"
      [content]="getFullName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.PHONE_LABEL'"
      [content]="getFormattedPhone()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.EMAIL_LABEL'"
      [content]="buyer?.email || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.TAX_CODE'"
      [content]="buyer?.tax_code || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.GENDER_LABEL'"
      [content]="buyer?.gender || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.CITIZENSHIP_LABEL'"
      [content]="buyer?.citizenship || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.SECONDARY_CITIZENSHIP_LABEL'"
      [content]="buyer?.secondary_citizenship || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.BIRTHDAY_LABEL'"
      [content]="(buyer?.birthday | date : 'shortDate') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.BIRTHREGION_LABEL'"
      [content]="buyer?.birthregion_code || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.BIRTHPLACE_LABEL'"
      [content]="buyer?.birthplace || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.BIRTHCOUNTRY_LABEL'"
      [content]="buyer?.birthcountry || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.COMMUNICATION_CHANNEL_LABEL'"
      [content]="getCommunicationChannel()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info-copy
      [label]="'SELLERS.SUB_COLUMN_LABEL'"
      [content]="buyer?.buyer_sub || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'BUYERS.CDG_LABEL'"
      [content]="buyer?.cdg || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info-copy
      [label]="'BUYERS.STRIPE_CUSTOMER_ID_LABEL'"
      [content]="buyer?.stripe_customer_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'BUYERS.LAST_EXPERIAN_ID_LABEL'"
      [content]="buyer?.last_experian_verification_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'BUYERS.LAST_FOURTHLINE_ID_LABEL'"
      [content]="buyer?.last_fourthline_verification_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'BUYERS.LAST_FEA_CONTRACT_ID_LABEL'"
      [content]="buyer?.last_fea_contract_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'BUYERS.LAST_CONTRACT_ID_LABEL'"
      [content]="contract_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'BUYERS.ORIGIN_ORDER_ID_LABEL'"
      [content]="buyer?.origin_order_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'BUYERS.ORIGIN_STORE_ID_LABEL'"
      [content]="buyer?.origin_store_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'BUYERS.ORIGIN_STORE_NAME_LABEL'"
      [content]="getStoreFullName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.ORIGIN_COLUMN_LABEL'"
      [content]="getOriginLabel()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
